import React, { useState, useEffect } from 'react';
import styles from 'components/radio-button/index.module.scss';
import className from 'classnames/bind';

const cx = className.bind(styles);

/**
 * @param title {string}
 * @param defaultValue {string}
 * @param data {Array}
 * @param theme {'default'|'brown'}
 * @param onClick {function}
 */
const RadioButton = ({ title = '', defaultValue = '', data = [], theme = 'default', onClick }) => {
  const [checked, setChecked] = useState('');

  const onChangeHandler = event => {
    setChecked(event.target.value);
  };

  useEffect(() => {
    setChecked(defaultValue);
  }, [defaultValue]);

  const radioButtonClass = cx({
    radioButton: true,
    [theme]: true,
  });

  return (
    <div className={styles.container}>
      {title && <div className={styles.title}>{title}</div>}
      <div className={radioButtonClass}>
        {data.map(x => {
          const carTypeClass = cx({
            active: x.key === checked,
          });

          return (
            <label key={x.key} htmlFor={x.key} className={carTypeClass}>
              <input
                id={x.key}
                value={x.key}
                checked={x.key === checked}
                name="vehicleType"
                type="radio"
                onChange={onChangeHandler}
                onClick={() => {
                  if (onClick) {
                    onClick(x.key);
                  }
                }}
              />
              <span>{x.value}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default RadioButton;
